import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth' // ou 'auto' si tu ne veux pas d’animation
    });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
